import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ApiServiceExtension } from 'src/app/core/extension/apiServiceExtension';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NlogService extends ApiServiceExtension {
    constructor(protected config: AppConfig, public http: HttpClient) {
        super(config, http);
    }

    public GetRecentlyByFilter(skip: number, take: number): Observable<any> {
        let url = `${this.API_URL}Nlog/GetRecentlyByFilter/?skip=${skip}&take=${take}`;
        return this.http.get(url);
    }
}
